import React, { Component } from 'react';
import { useParams, Link } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import ReactLoading from 'react-loading';
dayjs.locale('th');

class ProgramPlusViewInner extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: true, data: null };
    }

    componentDidMount() {
        var id = this.props.params?.id;
        if (!id) return;
        var isPublic = typeof window !== 'undefined' && !window.location.pathname.startsWith('/console');
        fetch('api/programplus/' + id + (isPublic ? '?publicOnly=1' : ''))
            .then(r => r.ok ? r.json() : null)
            .then(json => this.setState({ data: json, loading: false }))
            .catch(() => this.setState({ loading: false }));

        // Track view only when on public route (not /console)
        if (isPublic) {
            fetch('api/programplus/' + id + '/view', { method: 'POST' }).catch(() => {});
        }
    }

    renderMealIcon(hasIt) {
        return hasIt ? <i className="fas fa-check" style={{ color: '#dc3545' }}></i> : <span style={{ color: '#ccc' }}>-</span>;
    }

    getUpcomingPeriods(periods) {
        if (!periods || !periods.length) return [];
        var today = dayjs().format('YYYY-MM-DD');
        return periods.filter(p => p.endDate && dayjs(p.endDate).format('YYYY-MM-DD') >= today);
    }

    renderHighlightIcons(highlights) {
        return highlights.map((h, i) => (
            <div key={i} className="d-flex align-items-center mb-2" style={{ gap: 10 }}>
                <div style={{ width: 28, height: 28, background: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#dc3545', flexShrink: 0 }}>
                    <i className={h.icon}></i>
                </div>
                <span style={{ color: '#fff', fontSize: 14 }}>{h.text}</span>
            </div>
        ));
    }

    renderFlightBox(flights) {
        return (
            <div style={{ background: '#fff', borderRadius: 10, padding: 15, border: '1px solid #ddd' }}>
                <div className="text-center mb-2"><strong style={{ color: '#dc3545' }}>JAPAN AIRLINES</strong></div>
                <div className="row g-2" style={{ fontSize: 12 }}>
                    {flights.map((f, i) => (
                        <div key={i} className={'col-6 ' + (i % 2 === 0 ? 'border-end' : '')}>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 11, color: '#888' }}>{f.flightNo} ({f.departTime})</div>
                                <div className="d-flex align-items-center justify-content-center my-1" style={{ gap: 6 }}>
                                    <div>
                                        <div style={{ fontWeight: 700, fontSize: 14 }}>{f.routeFrom.split(' ')[0]}</div>
                                        <div style={{ fontSize: 10, color: '#888' }}>{f.routeFrom.split(' ').slice(1).join(' ')}</div>
                                    </div>
                                    <i className="fas fa-plane" style={{ color: '#dc3545' }}></i>
                                    <div>
                                        <div style={{ fontWeight: 700, fontSize: 14 }}>{f.routeTo.split(' ')[0]}</div>
                                        <div style={{ fontSize: 10, color: '#888' }}>{f.routeTo.split(' ').slice(1).join(' ')}</div>
                                    </div>
                                </div>
                                <div style={{ fontSize: 11, color: '#dc3545' }}>{f.direction === 'outbound' ? 'ขาไป' : 'ขากลับ'}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    renderHero(data, highlights, foods, flights) {
        return (
            <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: 20, overflow: 'hidden' }}>
                {/* Company header */}
                <div className="d-flex justify-content-between align-items-center p-3" style={{ borderBottom: '1px solid #eee' }}>
                    <div>
                        <img src="/images/slocan.png" alt="EXTEND HAPPINESS" style={{ height: 32, width: 'auto', objectFit: 'contain' }} />
                        <div style={{ fontSize: 10, color: '#aaa', marginTop: 4 }}>License 11/10538</div>
                    </div>
                    <div className="text-end">
                        <img src="/images/ANT_LOGO.png" alt="ANT" style={{ height: 48, width: 'auto', objectFit: 'contain' }} />
                    </div>
                </div>

                {/* Hero image with title overlay */}
                <div style={{ position: 'relative' }}>
                    {data.coverImg ? (
                        <div style={{ height: 520, overflow: 'hidden' }}>
                            <img src={data.coverImg} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                    ) : (
                        <div style={{ height: 520, background: 'linear-gradient(135deg,#f8c7c1 0%, #f0a0a0 40%, #dc3545 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textShadow: '0 2px 12px rgba(0,0,0,0.25)' }}>
                            <i className="fas fa-image" style={{ fontSize: 120, opacity: 0.55 }}></i>
                        </div>
                    )}

                    {/* Title overlay */}
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, padding: '20px 30px', background: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 60%, rgba(255,255,255,0) 100%)' }}>
                        <div className="d-flex align-items-start" style={{ gap: 14 }}>
                            <div style={{ background: '#2c2c2c', color: '#fff', padding: '8px 14px', borderRadius: 4, fontWeight: 800, fontSize: 14, flexShrink: 0 }}>{data.code}</div>
                            <div>
                                <h3 style={{ margin: 0, color: '#dc3545', fontWeight: 900, fontSize: 26, lineHeight: 1.15 }}>{data.name}</h3>
                                {data.destinations && (
                                    <div style={{ marginTop: 8, fontSize: 16, color: '#333', fontWeight: 500 }}>
                                        <i className="fas fa-map-marker-alt" style={{ color: '#dc3545', marginRight: 6 }}></i>
                                        {data.destinations}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Panels overlapping hero bottom + extending below */}
                <div style={{ position: 'relative', marginTop: -80, padding: '0 20px 20px 20px' }}>
                    <div className="row g-2 align-items-stretch">
                        {/* Red "ทำไม" panel - LEFT (tall) */}
                        <div className="col-md-3">
                            <div style={{ background: 'linear-gradient(135deg, #ec5a3e, #c02911)', borderRadius: 8, padding: 20, color: '#fff', height: '100%', boxShadow: '0 6px 20px rgba(0,0,0,0.3)' }}>
                                <h3 style={{ fontSize: 42, fontWeight: 900, margin: 0, lineHeight: 1, textAlign: 'center' }}>ทำไม</h3>
                                <div style={{ fontSize: 15, marginBottom: 18, marginTop: 4, textAlign: 'center' }}>ต้องไปกับเรา ?</div>
                                <div style={{ borderTop: '1px solid rgba(255,255,255,0.3)', paddingTop: 12 }}>
                                    {highlights?.map((h, i) => (
                                        <div key={i} className="d-flex align-items-center mb-2" style={{ gap: 10 }}>
                                            <div style={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0, fontSize: 13 }}>
                                                <i className={h.icon}></i>
                                            </div>
                                            <span style={{ color: '#fff', fontSize: 13, lineHeight: 1.3 }}>{h.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Center: small images (top) + flight (bottom) */}
                        <div className="col-md-6">
                            <div className="d-flex flex-column" style={{ gap: 10, height: '100%' }}>
                                {/* 2 small images */}
                                <div className="row g-2">
                                    {[data.coverSm1, data.coverSm2].map((img, i) => (
                                        <div key={i} className="col-6">
                                            <div style={{ position: 'relative', width: '100%', height: 170, borderRadius: 8, overflow: 'hidden', boxShadow: '0 4px 16px rgba(0,0,0,0.25)' }}>
                                                {img ? (
                                                    <img src={img} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                ) : (
                                                    <div style={{ width: '100%', height: '100%', background: 'linear-gradient(135deg,#fff 0%, #f3f3f3 100%)', border: '2px dashed #ddd', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb' }}>
                                                        <i className="fas fa-image" style={{ fontSize: 44 }}></i>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Flight card below the 2 images */}
                                {!flights?.length ? (
                                    <div style={{ flex: 1, minHeight: 120, background: 'linear-gradient(135deg,#fff 0%, #f3f3f3 100%)', borderRadius: 20, border: '2px dashed #ddd', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb', boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }}>
                                        <i className="fas fa-plane" style={{ fontSize: 48 }}></i>
                                    </div>
                                ) : (
                                    <div style={{ flex: 1, background: '#fff', borderRadius: 20, padding: '10px 16px 14px', border: '2px solid #f0a0a0', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                                        {/* Top: Logo + JAPAN AIRLINES (centered inside) */}
                                        <div className="d-flex align-items-center justify-content-center mb-2" style={{ gap: 8 }}>
                                            {data.airlineLogo ? (
                                                <img src={data.airlineLogo} alt={data.airlineName} style={{ height: 40, width: 'auto', objectFit: 'contain' }} />
                                            ) : data.airlineName ? (
                                                <div style={{ background: '#c8102e', color: '#fff', borderRadius: '50%', width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 18 }}>{data.airlineName.charAt(0)}</div>
                                            ) : (
                                                <div style={{ width: 56, height: 40, border: '2px dashed #ccc', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb' }}>
                                                    <i className="fas fa-plane" style={{ fontSize: 22 }}></i>
                                                </div>
                                            )}
                                            {data.airlineName && (
                                                <div style={{ fontSize: 12, fontWeight: 900, color: '#222', lineHeight: 1.1, fontStyle: 'italic', textTransform: 'uppercase' }}>
                                                    {data.airlineName.split(' ').map((w, i) => <div key={i}>{w}</div>)}
                                                </div>
                                            )}
                                        </div>

                                        {/* Flight rows side by side with red divider */}
                                        <div className="d-flex" style={{ gap: 0 }}>
                                            {flights.map((f, i) => {
                                                var duration = '';
                                                try {
                                                    var [dh, dm] = f.departTime.split('.').map(Number);
                                                    var [ah, am] = f.arriveTime.split('.').map(Number);
                                                    var depMin = dh*60 + (dm||0);
                                                    var arrMin = ah*60 + (am||0);
                                                    var diff = arrMin - depMin;
                                                    if (diff < 0) diff += 24*60;
                                                    var hrs = Math.floor(diff/60);
                                                    var mins = diff%60;
                                                    duration = hrs + '.' + (mins<10?'0':'') + mins + ' ชั่วโมง';
                                                } catch {}

                                                return (
                                                    <React.Fragment key={i}>
                                                        {i > 0 && <div style={{ width: 2, background: '#dc3545', margin: '0 6px', borderRadius: 1 }}></div>}
                                                        <div style={{ flex: 1, padding: '0 4px' }}>
                                                            {/* Flight numbers row */}
                                                            <div className="d-flex justify-content-between align-items-center" style={{ fontSize: 11, color: '#666', marginBottom: 2 }}>
                                                                <span style={{ fontWeight: 600 }}>{f.flightNo} ({f.departTime})</span>
                                                                <i className="fas fa-plane" style={{ color: '#c8102e', fontSize: 11 }}></i>
                                                                <span style={{ fontWeight: 600 }}>{f.flightNo} ({f.arriveTime})</span>
                                                            </div>
                                                            {/* Airport codes row */}
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div style={{ textAlign: 'center', minWidth: 60 }}>
                                                                    <div style={{ fontWeight: 900, fontSize: 22, lineHeight: 1, color: '#222', letterSpacing: 1 }}>{f.routeFrom.split(' ')[0]}</div>
                                                                    <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>{f.routeFrom.split(' ').slice(1).join(' ')}</div>
                                                                </div>
                                                                <div style={{ flex: 1, textAlign: 'center', paddingTop: 8 }}>
                                                                    <div style={{ fontSize: 10, color: '#666', lineHeight: 1 }}>{duration}</div>
                                                                    <div style={{ height: 1, background: '#999', margin: '4px 4px 0' }}></div>
                                                                </div>
                                                                <div style={{ textAlign: 'center', minWidth: 60 }}>
                                                                    <div style={{ fontWeight: 900, fontSize: 22, lineHeight: 1, color: '#222', letterSpacing: 1 }}>{f.routeTo.split(' ')[0]}</div>
                                                                    <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>{f.routeTo.split(' ').slice(1).join(' ')}</div>
                                                                </div>
                                                            </div>
                                                            {/* ขาไป/ขากลับ */}
                                                            <div style={{ textAlign: 'center', fontSize: 12, color: '#222', marginTop: 2, fontWeight: 700, textDecoration: 'underline', textUnderlineOffset: 3 }}>
                                                                {f.direction === 'outbound' ? 'ขาไป' : 'ขากลับ'}
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    )}
                            </div>
                        </div>

                        {/* Food highlights - RIGHT (tall) */}
                        <div className="col-md-3">
                            <div style={{ background: '#fff', borderRadius: 8, padding: 14, height: '100%', boxShadow: '0 6px 20px rgba(0,0,0,0.3)' }}>
                                <h6 style={{ color: '#dc3545', textAlign: 'center', fontWeight: 800, fontSize: 17, marginBottom: 12, borderBottom: '1px dashed #dc3545', paddingBottom: 8 }}>{data.foodTitle || 'ไม่พลาดเมนูเด็ด!'}</h6>
                                {foods?.slice(0, 3).map((f, i) => (
                                    <div key={i} className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
                                        {f.image ? <img src={f.image} alt="" style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: '2px solid #f5f5f5' }} /> : <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#f0f0f0', flexShrink: 0 }}></div>}
                                        <div>
                                            <div style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.2, color: '#333' }}>{f.name}</div>
                                            <div style={{ fontSize: 11, color: '#888', lineHeight: 1.3, marginTop: 2 }}>{f.desc}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderFlightSection(flights) {
        if (!flights?.length) return null;
        return (
            <div className="mb-3" style={{ maxWidth: 700, margin: '0 auto 20px auto' }}>
                {this.renderFlightBox(flights)}
            </div>
        );
    }

    renderSpecialAndPrice(data, periods) {
        return (
            <div className="row mb-3">
                <div className="col-md-4 mb-2">
                    {data.specialNote ? (
                        <div style={{ background: '#fff', borderRadius: 10, padding: 15, border: '2px dashed #dc3545', textAlign: 'center', height: '100%' }}>
                            <i className="fas fa-thumbs-up" style={{ color: '#dc3545', fontSize: 24 }}></i>
                            <div style={{ fontSize: 13, color: '#dc3545', fontWeight: 700, marginTop: 4 }}>พิเศษยิ่งกว่า</div>
                            <div style={{ fontSize: 13, color: '#555', marginTop: 4, whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{data.specialNote}</div>
                        </div>
                    ) : (
                        <div style={{ background: 'linear-gradient(135deg,#fff 0%, #f3f3f3 100%)', borderRadius: 10, padding: 20, border: '2px dashed #ddd', height: '100%', minHeight: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#bbb' }}>
                            <i className="fas fa-thumbs-up" style={{ fontSize: 32 }}></i>
                            <div style={{ fontSize: 12, marginTop: 6, color: '#999' }}>พิเศษยิ่งกว่า</div>
                        </div>
                    )}
                </div>
                <div className="col-md-5 mb-2">
                    {periods?.length > 0 ? (
                        <div style={{ background: '#fff', borderRadius: 10, padding: 14, border: '1px solid #eee', height: '100%' }}>
                            <div style={{ fontSize: 12, color: '#888', textAlign: 'center', marginBottom: 6 }}>กำหนดการเดินทาง</div>
                            {periods.map((p, i) => (
                                <div key={i} style={{ fontSize: 16, fontWeight: 800, color: '#dc3545', textAlign: 'center', padding: '4px 0', borderTop: i > 0 ? '1px dashed #eee' : 'none' }}>
                                    {dayjs(p.startDate).format('DD')} - {dayjs(p.endDate).format('DD MMMM')} {parseInt(dayjs(p.endDate).format('YYYY')) + 543}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{ background: 'linear-gradient(135deg,#fff 0%, #f3f3f3 100%)', borderRadius: 10, padding: 20, border: '2px dashed #ddd', height: '100%', minHeight: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#bbb' }}>
                            <i className="fas fa-calendar-alt" style={{ fontSize: 32 }}></i>
                            <div style={{ fontSize: 12, marginTop: 6, color: '#999' }}>ยังไม่มีรอบการเดินทาง</div>
                        </div>
                    )}
                </div>
                <div className="col-md-3 mb-2">
                    <div style={{ background: '#fff', borderRadius: 10, padding: 16, textAlign: 'center', border: '1px solid #eee', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 10 }}>
                        <div>
                            <div style={{ fontSize: 11, color: '#888' }}>เริ่มต้น</div>
                            <div style={{ fontSize: 28, fontWeight: 800, color: '#dc3545', lineHeight: 1.1 }}>
                                {Number(data.startPrice).toLocaleString()}.-
                            </div>
                        </div>
                        <button type="button" className="btn btn-danger btn-sm" style={{ fontWeight: 700, borderRadius: 20 }}
                            onClick={() => window.dispatchEvent(new CustomEvent('open-contact-form', { detail: { message: 'สนใจโปรแกรม ' + (data.code || '') + ' ' + (data.name || '') + '\nต้องการสอบถามรายละเอียดเพิ่มเติม' } }))}>
                            <i className="fas fa-paper-plane"></i> สนใจโปรแกรมนี้
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderItineraryTable(itinerary) {
        var thStyle = { background: '#dc3545', color: '#fff', border: 'none', fontSize: 16, fontWeight: 700, verticalAlign: 'middle' };

        // Collect unique icons used across all days
        var uniqueIcons = {};
        (itinerary || []).forEach(d => {
            (d.icons || []).forEach(ic => {
                if (!uniqueIcons[ic.iconId]) uniqueIcons[ic.iconId] = ic;
            });
        });
        var iconList = Object.values(uniqueIcons);

        return (
            <div style={{ background: '#fff', borderRadius: 10, overflow: 'hidden', border: '1px solid #eee', marginBottom: 20 }}>
                <table className="table mb-0" style={{ fontSize: 13 }}>
                    <thead>
                        <tr>
                            <th rowSpan="2" style={{ ...thStyle, width: 60, textAlign: 'center' }}>วันที่</th>
                            <th rowSpan="2" style={{ ...thStyle, textAlign: 'center' }}>โปรแกรมการเดินทาง</th>
                            <th colSpan="3" style={{ ...thStyle, textAlign: 'center', width: 150 }}>มื้ออาหาร</th>
                            <th rowSpan="2" style={{ ...thStyle, width: 200, textAlign: 'center' }}>โรงแรม</th>
                        </tr>
                        <tr>
                            <th style={{ ...thStyle, textAlign: 'center', fontSize: 14 }}>เช้า</th>
                            <th style={{ ...thStyle, textAlign: 'center', fontSize: 14 }}>กลางวัน</th>
                            <th style={{ ...thStyle, textAlign: 'center', fontSize: 14 }}>เย็น</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itinerary?.map((d, i) => (
                            <tr key={i}>
                                <td style={{ textAlign: 'center', fontWeight: 700 }}>{d.dayNo}</td>
                                <td>{d.title}</td>
                                <td style={{ textAlign: 'center' }}>{this.renderMealIcon(d.breakfast)}</td>
                                <td style={{ textAlign: 'center' }}>{this.renderMealIcon(d.lunch)}</td>
                                <td style={{ textAlign: 'center' }}>{this.renderMealIcon(d.dinner)}</td>
                                <td>
                                    {d.hotelName && <>
                                        <div style={{ fontSize: 13, fontWeight: 700, color: '#dc3545' }}>{d.hotelName}</div>
                                        {d.hotelUrl && <a href={d.hotelUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: 10, color: '#007bff' }}>{d.hotelUrl}</a>}
                                        {d.hotelNote && <div style={{ fontSize: 11, color: '#888' }}>**{d.hotelNote}</div>}
                                    </>}
                                    {d.icons?.length > 0 && (
                                        <div className="d-flex flex-wrap mt-1" style={{ gap: 4 }}>
                                            {d.icons.map((ic, ii) => (
                                                <span key={ii} title={ic.iconName}
                                                    style={{ width: 24, height: 24, borderRadius: '50%', background: '#dc3545', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 11 }}>
                                                    <i className={ic.iconClass}></i>
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    {iconList.length > 0 && (
                        <tfoot>
                            <tr style={{ background: '#fafafa' }}>
                                <td colSpan="6" style={{ borderTop: '2px solid #dc3545', padding: 12 }}>
                                    <div className="d-flex align-items-center justify-content-center flex-wrap" style={{ gap: 16 }}>
                                        <span style={{ background: '#dc3545', color: '#fff', padding: '6px 14px', borderRadius: 4, fontWeight: 700, fontSize: 13, flexShrink: 0 }}>สัญลักษณ์หมายถึง</span>
                                        {iconList.map((ic, ii) => (
                                            <div key={ii} className="d-flex align-items-center" style={{ gap: 6 }}>
                                                <span style={{ width: 30, height: 30, borderRadius: '50%', background: '#dc3545', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>
                                                    <i className={ic.iconClass}></i>
                                                </span>
                                                <span style={{ fontSize: 12, color: '#555', whiteSpace: 'nowrap' }}>{ic.iconName}</span>
                                            </div>
                                        ))}
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>
        );
    }

    renderDayDetail(day) {
        return (
            <div key={day.id} style={{ background: '#fff', borderRadius: 10, border: '1px solid #eee', marginBottom: 20, overflow: 'hidden' }}>
                <div style={{ background: '#f8f9fa', padding: 15, borderBottom: '2px solid #dc3545' }}>
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                        <div style={{ background: '#dc3545', color: '#fff', padding: '6px 14px', borderRadius: 4, fontWeight: 700, fontSize: 13 }}>
                            {day.details?.[0]?.dayLabel || ('วันที่ ' + day.dayNo)}
                        </div>
                        <div style={{ fontSize: 15, fontWeight: 600 }}>{day.title}</div>
                    </div>
                </div>

                <div className="p-3">
                    {day.details?.map((det, i) => (
                        <div key={i} className="d-flex mb-3" style={{ gap: 15 }}>
                            <div style={{ minWidth: 80, fontWeight: 700, color: '#dc3545', fontSize: 13 }}>{det.timeLabel}</div>
                            <div style={{ flex: 1, fontSize: 13, lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: det.content }}></div>
                        </div>
                    ))}

                    {day.images?.length > 0 && (
                        <div className="row g-2 mt-2">
                            {day.images.map((img, i) => (
                                <div key={i} className="col-md-4 col-6">
                                    <div style={{ borderRadius: 8, overflow: 'hidden', height: 140 }}>
                                        <img src={img.image} alt={img.caption} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                    {img.caption && <div style={{ fontSize: 11, color: '#888', marginTop: 4, textAlign: 'center' }}>{img.caption}</div>}
                                </div>
                            ))}
                        </div>
                    )}

                    {(day.hotelName || day.hotelUrl) && (
                        <div className="mt-3 p-2" style={{ background: '#fafafa', borderRadius: 6, fontSize: 12 }}>
                            <strong style={{ color: '#dc3545' }}>นำท่านเข้าสู่ที่พัก</strong> {day.hotelName}
                            {day.hotelNote && <span> {day.hotelNote}</span>}
                            {day.hotelUrl && <div><a href={day.hotelUrl} target="_blank" rel="noopener noreferrer">{day.hotelUrl}</a></div>}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderPriceTable(periods) {
        if (!periods?.length) {
            return (
                <div style={{ background: 'linear-gradient(135deg,#fff 0%, #f3f3f3 100%)', borderRadius: 10, padding: 40, border: '2px dashed #ddd', textAlign: 'center', color: '#bbb', marginBottom: 20 }}>
                    <i className="fas fa-calendar-times" style={{ fontSize: 48 }}></i>
                    <div style={{ fontSize: 14, marginTop: 10, color: '#999', fontWeight: 600 }}>ยังไม่มีรอบการเดินทางที่เปิดจอง</div>
                </div>
            );
        }
        var rowDef = [
            { label: 'ผู้ใหญ่อายุ 12 ปีขึ้นไป พักห้องละ 2-3 ท่าน', wt: 'adultPrice', nt: 'adultNoTicket' },
            { label: 'เด็กอายุ 7-11 ปี พักรวมผู้ใหญ่ มีเตียง', wt: 'childBed', nt: 'childBedNoTicket' },
            { label: 'เด็กอายุ 2-6 ปี พักรวมผู้ใหญ่ ไม่มีเตียง', wt: 'childNoBed', nt: 'childNoBedNoTicket' },
            { label: 'พักห้องเดี่ยว เพิ่มอีกท่านละ', wt: 'singleSuppl', nt: 'singleNoTicket' }
        ];

        // Group periods by identical price signature
        var priceKey = (p) => rowDef.map(r => Number(p[r.wt]) + '|' + Number(p[r.nt])).join(',');
        var groups = [];
        periods.forEach(p => {
            var key = priceKey(p);
            var existing = groups.find(g => g.key === key);
            if (existing) existing.periods.push(p);
            else groups.push({ key, periods: [p], sample: p });
        });

        var formatDate = (p) => dayjs(p.startDate).format('DD') + ' – ' + dayjs(p.endDate).format('DD MMMM') + ' ' + (parseInt(dayjs(p.endDate).format('YYYY')) + 543);

        return (
            <div style={{ background: '#fff', borderRadius: 10, padding: 20, border: '1px solid #eee', marginBottom: 20 }}>
                <h4 style={{ textAlign: 'center', fontWeight: 800, marginBottom: 15 }}>อัตราค่าบริการ</h4>
                {groups.map((g, idx) => (
                    <div key={idx} className="mb-4">
                        <div style={{ fontSize: 13, marginBottom: 10 }}>
                            <strong>กำหนดการเดินทาง</strong>
                            {g.periods.map((p, i) => (
                                <div key={i} style={{ color: '#dc3545', paddingLeft: 14 }}>
                                    • {formatDate(p)}
                                    {p.desc && <span style={{ color: '#888', marginLeft: 8, fontSize: 12 }}>({p.desc})</span>}
                                </div>
                            ))}
                        </div>
                        <table className="table table-bordered" style={{ fontSize: 13, marginBottom: 0 }}>
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <th>ท่านละ</th>
                                    <th style={{ textAlign: 'right', color: '#dc3545' }}>ราคารวมตั๋ว</th>
                                    <th style={{ textAlign: 'right', color: '#dc3545' }}>ราคาไม่รวมตั๋ว</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rowDef.map((r, i) => (
                                    <tr key={i}>
                                        <td>{r.label}</td>
                                        <td style={{ textAlign: 'right', color: '#dc3545', fontWeight: 700 }}>{Number(g.sample[r.wt]).toLocaleString()}.-</td>
                                        <td style={{ textAlign: 'right', color: '#dc3545', fontWeight: 700 }}>{Number(g.sample[r.nt]).toLocaleString()}.-</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        );
    }

    renderConditionSection(title, content, color) {
        if (!content || content === '<p></p>' || content === '<p><br></p>') return null;
        return (
            <div className="mb-3">
                <div style={{ background: color || '#ffd700', color: '#333', padding: '4px 12px', borderRadius: 4, display: 'inline-block', fontWeight: 700, fontSize: 13, marginBottom: 8 }}>
                    {title}
                </div>
                <div style={{ fontSize: 13, lineHeight: 1.7, paddingLeft: 8 }} dangerouslySetInnerHTML={{ __html: content }}></div>
            </div>
        );
    }

    render() {
        const { loading, data } = this.state;

        if (loading) {
            var skelBox = (h) => <div style={{ background:'#eee', borderRadius:10, height:h, width:'100%' }}></div>;
            return (
                <div style={{ background: '#f4f3ef', minHeight: '100vh', padding: 20 }}>
                    <div style={{ maxWidth: 1000, margin: '0 auto' }}>
                        <div style={{ background:'#fff', borderRadius:12, boxShadow:'0 4px 20px rgba(0,0,0,0.08)', marginBottom: 20, overflow:'hidden' }}>
                            {skelBox(520)}
                            <div style={{ padding:20 }}>
                                <div className="row g-2">
                                    <div className="col-md-3">{skelBox(160)}</div>
                                    <div className="col-md-6">
                                        <div className="row g-2 mb-2">
                                            <div className="col-6">{skelBox(80)}</div>
                                            <div className="col-6">{skelBox(80)}</div>
                                        </div>
                                        {skelBox(72)}
                                    </div>
                                    <div className="col-md-3">{skelBox(160)}</div>
                                </div>
                            </div>
                        </div>
                        <div className="row g-2 mb-3">
                            <div className="col-md-4">{skelBox(100)}</div>
                            <div className="col-md-5">{skelBox(100)}</div>
                            <div className="col-md-3">{skelBox(100)}</div>
                        </div>
                        {skelBox(260)}
                        <div className="text-center py-4">
                            <ReactLoading type={'cylon'} color={'#dc3545'} height={70} width={70} className="d-inline-block" />
                            <div className="mt-2" style={{ color:'#999' }}>กำลังโหลดโปรแกรมทัวร์...</div>
                        </div>
                    </div>
                </div>
            );
        }
        if (!data) return <div className="text-center py-5"><i className="fas fa-exclamation-circle fa-3x text-muted"></i><div className="mt-3">ไม่พบโปรแกรมทัวร์</div></div>;

        var p = data.data;
        return (
            <div className="program-plus-view" style={{ background: '#f4f3ef', minHeight: '100vh', padding: 20, fontSize: 16, lineHeight: 1.5 }}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500;600;700;800&display=swap');
                    .program-plus-view,
                    .program-plus-view div,
                    .program-plus-view span,
                    .program-plus-view p,
                    .program-plus-view td,
                    .program-plus-view th,
                    .program-plus-view a,
                    .program-plus-view label,
                    .program-plus-view button,
                    .program-plus-view h1, .program-plus-view h2, .program-plus-view h3,
                    .program-plus-view h4, .program-plus-view h5, .program-plus-view h6,
                    .program-plus-view li, .program-plus-view ol, .program-plus-view ul,
                    .program-plus-view input, .program-plus-view select, .program-plus-view textarea {
                        font-family: 'Prompt', 'Helvetica Neue', Arial, sans-serif !important;
                    }
                    .program-plus-view i.fa, .program-plus-view i.fas, .program-plus-view i.far, .program-plus-view i.fab, .program-plus-view i.fal, .program-plus-view i.fad {
                        font-family: 'Font Awesome 5 Free', 'Font Awesome 6 Free', 'FontAwesome' !important;
                    }
                    .program-plus-view i.fab { font-family: 'Font Awesome 5 Brands', 'Font Awesome 6 Brands' !important; }
                    .program-plus-view table { font-size: 15px !important; }
                    .program-plus-view td, .program-plus-view th { font-size: 15px !important; }
                    .program-plus-view p { font-size: 15px !important; line-height: 1.7 !important; margin-bottom: 8px; }
                    .program-plus-view li { font-size: 15px !important; line-height: 1.7 !important; }
                    .program-plus-view h4 { font-size: 22px !important; }
                    .program-plus-view h5 { font-size: 20px !important; }
                    .program-plus-view h6 { font-size: 17px !important; }
                `}</style>
                <div style={{ maxWidth: 1000, margin: '0 auto' }}>
                    {/* Navigation */}
                    {(() => {
                        var isConsole = typeof window !== 'undefined' && window.location.pathname.startsWith('/console');
                        var goBack = () => {
                            if (window.history.length > 1) window.history.back();
                            else window.location.href = isConsole ? '/console/programplus' : '/';
                        };
                        return (
                            <div className="d-flex justify-content-between align-items-center mb-3 no-print">
                                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={goBack}><i className="fas fa-arrow-left"></i> กลับ</button>
                                <div>
                                    {isConsole && <Link to={'/console/programplus/edit/' + p.id} className="btn btn-outline-primary btn-sm me-2" style={{ marginRight: 8 }}><i className="fas fa-edit"></i> แก้ไข</Link>}
                                    {p.pdfFile && <a href={p.pdfFile} target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger btn-sm me-2" style={{ marginRight: 8 }}><i className="fas fa-file-pdf"></i> ดาวน์โหลด PDF</a>}
                                    <button className="btn btn-dark btn-sm" onClick={() => window.print()}><i className="fas fa-print"></i> พิมพ์</button>
                                </div>
                            </div>
                        );
                    })()}

                    {/* Hero with overlapping panels (title + red + small images + flight + food) */}
                    {this.renderHero(p, data.highlights, data.foods, data.flights)}

                    {/* Special & Price */}
                    {this.renderSpecialAndPrice(p, this.getUpcomingPeriods(data.periods))}

                    {/* Itinerary Table */}
                    {data.itinerary?.length > 0 && this.renderItineraryTable(data.itinerary)}

                    {/* Day-by-Day Detail */}
                    <h4 style={{ color: '#dc3545', fontWeight: 800, marginTop: 30 }}><i className="fas fa-route"></i> รายละเอียดการเดินทาง</h4>
                    {data.itinerary?.map(day => this.renderDayDetail(day))}

                    {/* Price Table */}
                    {this.renderPriceTable(this.getUpcomingPeriods(data.periods))}

                    {/* Conditions */}
                    <div style={{ background: '#fff', borderRadius: 10, padding: 25, border: '1px solid #eee', marginBottom: 20 }}>
                        {this.renderConditionSection('อัตรานี้รวม', p.include, '#ffd700')}
                        {this.renderConditionSection('อัตรานี้ไม่รวม', p.exclude, '#ffd700')}
                        {this.renderConditionSection('เงื่อนไขการจอง', p.bookingCondition, '#ffd700')}
                        {this.renderConditionSection('เงื่อนไขการเดินทาง', p.travelCondition, '#ffd700')}
                        {this.renderConditionSection('ตั๋วเครื่องบิน', p.ticketCondition, '#ffd700')}
                        {this.renderConditionSection('ค่าธรรมเนียมน้ำมันเชื้อเพลิงและค่าประกันวินาศภัยทางอากาศ', p.fuelInsurance, '#ffd700')}
                        {this.renderConditionSection('กระเป๋าและสัมภาระการเดินทาง', p.baggage, '#ffd700')}
                        {this.renderConditionSection('กรณียกเลิกการเดินทาง', p.cancellation, '#ffd700')}
                    </div>

                    <div className="text-center py-3" style={{ color: '#999', fontSize: 12 }}>
                        *************************<br/>
                        {p.code} {p.name}
                    </div>
                </div>

                <style>{`
                    @media print {
                        .no-print { display: none !important; }
                        body { background: #fff !important; }
                    }
                `}</style>
            </div>
        );
    }
}

export function ProgramPlusView(props) {
    var params = useParams();
    return <ProgramPlusViewInner {...props} params={params} />;
}
